import { render, staticRenderFns } from "./body.vue?vue&type=template&id=fe69f828"
import script from "./body.vue?vue&type=script&setup=true&lang=js"
export * from "./body.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports